import './index.css'
import * as React from 'react'
import { MdError as ErrorIcon } from '@react-icons/all-files/md/MdError'
import { Link } from 'react-router-dom'
type Props = {
  messageId: 'OVERDUE_BANKWIRE' | 'OVERDUE_DEFAULT'
}

const PaymentOverdueBanner = (props: Props): React.ReactElement<'div'> => {
  let { messageId } = props
  let msg

  switch (messageId) {
    case 'OVERDUE_BANKWIRE':
      msg = (
        <span>
          We have not received payment for your account. Please make payment as
          soon as possible to avoid disruption to your account.
        </span>
      )
      break

    case 'OVERDUE_DEFAULT':
      msg = (
        <span>
          We were unable to process payment for your account. Please{' '}
          <Link to="/settings/billing/update">
            update your billing details.
          </Link>
        </span>
      )
      break
  }

  return (
    <div className="payment-overdue">
      <ErrorIcon
        width="1.5em"
        height="1.5em"
        color="#fff"
        style={{
          margin: '0 1rem 0 1.3rem',
        }}
      />
      {msg}
    </div>
  )
}

export default PaymentOverdueBanner
